import { COLORS, TYPOGRAPHY } from '@app/constants';
import Button from '@app/ui/components/Button';
import { useRouter } from 'next/router';
import { FC } from 'react';
import styled from 'styled-components';
import emptyState from '@app/assets/images/empty-state.svg';
import Image from 'next/image';
import { BreakpointsEnum } from '@app/types';
import { useAppSelector } from '@app/store/hooks';
import { selectors } from '@app/store';
import { getHomepagePathByRole } from '@app/helpers/getHomepagePathByRole';

interface Props {
  className?: string;
}

const ClientError: FC<Props> = () => {
  const userRole = useAppSelector(selectors.auth.selectRole);
  const router = useRouter();

  const handleClick = () => {
    const homepagePath = getHomepagePathByRole(userRole);
    router.push(homepagePath);
  };

  return (
    <Root>
      <TitleWrapper>
        <ImageWrapper>
          <Image
            src={emptyState.src}
            width={303}
            height={172}
            alt="Картинка животного для красоты"
          />
        </ImageWrapper>
        <Title>404</Title>
      </TitleWrapper>
      <Text>
        Кажется что-то пошло не так. Страница, на которую вы хотели перейти, не
        найдена.
      </Text>
      <StyledButton styleType="primary" isLarge onClick={handleClick}>
        Вернуться
      </StyledButton>
    </Root>
  );
};

export default ClientError;

const Root = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 62px);
  padding-top: 40px;
  padding-bottom: 40px;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    position: relative;
  }
`;

const TitleWrapper = styled.div`
  position: relative;
`;

const ImageWrapper = styled.div`
  max-width: 303px;
  width: 100%;
  position: absolute;
  top: -22%;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);

  @media (max-width: ${BreakpointsEnum.sm}px) {
    top: -45%;
  }
`;

const Title = styled.h1`
  font-weight: 600;
  font-size: 200px;
  line-height: 239px;
  color: ${COLORS.primary300};
  margin-bottom: 16px;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    font-size: 100px;
    line-height: 95px;
  }
`;

const Text = styled.p`
  ${TYPOGRAPHY.headline1Medium18};
  color: ${COLORS.black};
  text-align: center;
  margin-bottom: 56px;
  max-width: 461px;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    ${TYPOGRAPHY.headline2Medium16};
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
  max-width: 376px;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    justify-self: flex-end;
    position: absolute;
    bottom: 40px;
  }
`;
